import React from 'react'
import './Package1.css';
// import { useTranslation } from 'react-i18next';
import PackagePrice from './PackagePrice';
import moaz from '../../../images/yassermoaz.jpeg';
import im1 from '../../../images/package1_test.png';
import im2 from '../../../images/package2_test.png';
import im3 from '../../../images/package3_test.png';
import im4 from '../../../images/wasswass.png';
import useWindowSize from '../../../hooks/useWindowSize';
const Package1 = () => {
    // const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const price = 45;
    return (
      <div className='package_1_main'>
        <div className='offers_all'>
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im1}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im3}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im4}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im1}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im4}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={moaz}
          />
          {width>500&&<>
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im3}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={moaz}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im1}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im3}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im1}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im2}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={im4}
          />
          <PackagePrice 
                  text={'text this is fusha web application for reserving and send problems'} 
                  country={'syria'}
                  price={price}
                  img={moaz}
          />
          </>}
        </div>
      </div>
    )
}

export default Package1